import Base from '../../base';
import Table from './calculator-table';

class CalculatorTableWarrant extends Base {
	constructor(el, options) {
		super(el, options);

		this.table = new Table(this.el, this.refs, this.options);
	}

	update(response) {
		this.table.update(response);
		this.updateRowStates(response);
	}

	updateRowStates(response) {
		const { options } = response;
		const { rowDelta, rowLeverage } = this.refs;
		const hasRows = rowDelta && rowLeverage;

		if (!hasRows) {
			console.warn('not all required rows are present');

			return;
		}

		const { shouldHideDeltaAndLeverage = false } = options;

		rowDelta.classList.toggle('is-hidden', shouldHideDeltaAndLeverage);
		rowLeverage.classList.toggle('is-hidden', shouldHideDeltaAndLeverage);
	}
}

export default CalculatorTableWarrant;
